import { useEffect, useState } from "react";

import { FolderCartographie } from "src/brand/EC/components/folder/FolderCartographie";
import { FolderDetailsEC } from "src/brand/EC/components/folder/FolderDetails";
import { FolderFooterEC } from "src/brand/EC/components/folder/footer/FolderFooter";
import { FolderHeaderEC } from "src/brand/EC/components/folder/header/FolderHeader";
import { SpinnerFullPage } from "src/core/components/custom-ui/spinner-full-page";
import { CompareCustomerModal } from "src/core/components/folder/CompareCustomerModal";
import { EntityDetailsModal } from "src/core/components/folder/entities/EntityDetailsModal";
import { FolderGraph } from "src/core/components/folder/FolderGraph";
import { FolderMessageThread } from "src/core/components/folder/FolderMessageThread";
import { AddStakeholderModal } from "src/core/components/folder/stakeholders/AddStakeholderModal";
import { DeleteStakeholderModal } from "src/core/components/folder/stakeholders/DeleteStakeholderModal";
import { ViewModificationModal } from "src/core/components/folder/ViewModificationModal";
import { Status } from "src/core/constants/folders";
import { useFolder } from "src/core/contexts/FolderContext";
import { useFolderGraphSync } from "src/core/contexts/FolderGraphSyncContext";
import { useCompareAfterReexamination } from "src/core/hooks/folder/useCompareAfterReexamination";
import { cn } from "src/core/lib/utils";

export const FolderContentEC = () => {
  const {
    compareData,
    compareLoading,
    handleFolderAccess,
    openCompareCustomerModal,
    setOpenCompareCustomerModal,
    openViewModificationsModal,
    setOpenViewModificationsModal,
    handleViewModifications,
    returnToFolder,
  } = useCompareAfterReexamination();

  const {
    openAddModal,
    setOpenAddModal,
    openDeleteModal,
    setOpenDeleteModal,
    handleSuccess,
    selectedStakeholder,
    selectedTab,
    setSelectedTab,
    openEntityDetailsModal,
    setOpenEntityDetailsModal,
    selectedEntity,
  } = useFolderGraphSync();

  const { folderFile, isPPH } = useFolder();

  const folderState = folderFile.folderFile?.workflowStatus?.state?.code;
  const isValidation =
    folderState === Status.VALIDATION_PENDING || folderState === Status.VALIDATION_PENDING_HR;
  const isDraft = folderState === Status.DRAFT;

  const [selectedDetailsTab, setSelectedDetailsTab] = useState<string>(
    isValidation ? "validation" : "elements"
  );

  const handleTabChange = (value: string) => {
    setSelectedDetailsTab(value);
    if (value === "validation") {
      setSelectedTab("cartographie");
    } else {
      setSelectedTab("elements");
    }
  };

  useEffect(() => {
    if (isValidation) {
      setSelectedDetailsTab("validation");
    } else {
      setSelectedDetailsTab("elements");
    }
  }, [isValidation]);
  // Callback pour changer l'onglet vers "validation" après l'acceptation de la mission
  const handleAfterValidationRefetch = () => {
    setSelectedDetailsTab("validation");
    setSelectedTab("cartographie");
  };
  if (compareLoading) {
    return <SpinnerFullPage />;
  }

  return (
    <>
      <div className="folder-wrapper">
        <FolderHeaderEC />
        <div className={cn("folder-content-wrapper")}>
          <FolderMessageThread />
          {selectedTab === "cartographie" || selectedDetailsTab === "validation" ? (
            <FolderCartographie />
          ) : (
            !isPPH && <FolderGraph />
          )}
          <FolderDetailsEC
            isDraft={isDraft}
            selectedDetailsTab={selectedDetailsTab}
            handleTabChange={handleTabChange}
            isPPH={isPPH}
          />
        </div>
      </div>
      <FolderFooterEC onAfterValidationRefetch={handleAfterValidationRefetch} />
      <AddStakeholderModal
        open={openAddModal}
        setOpen={setOpenAddModal}
        onCreateSuccess={handleSuccess}
      />
      <DeleteStakeholderModal
        open={openDeleteModal}
        setOpen={setOpenDeleteModal}
        stakeholder={selectedStakeholder}
        onSuccess={() => {
          handleSuccess();
          setOpenDeleteModal(false);
        }}
      />
      <EntityDetailsModal
        open={openEntityDetailsModal}
        setOpen={setOpenEntityDetailsModal}
        entity={selectedEntity}
      />
      <CompareCustomerModal
        open={openCompareCustomerModal}
        setOpen={setOpenCompareCustomerModal}
        compareData={compareData?.compareCustomerGraphWithExternalData}
        onFolderAccess={handleFolderAccess}
        onViewModifications={handleViewModifications}
      />
      {compareData?.compareCustomerGraphWithExternalData && (
        <ViewModificationModal
          open={openViewModificationsModal}
          setOpen={setOpenViewModificationsModal}
          compareData={compareData.compareCustomerGraphWithExternalData}
          onFolderAccess={returnToFolder}
        />
      )}
    </>
  );
};
